module.exports = [function () {
  return {
    restrict: 'E',
    scope: true,
    template: function () {
      return "<ion-item class='skeleton' ng-repeat='item in loadingItems'><div class='skeleton-avatar'></div><div class='skeleton-content'><div class='skeleton-content-wrapper'><div class='skeleton-content-item skeleton-item-first'></div><div class='skeleton-content-item skeleton-item-second'></div><div class='skeleton-content-item skeleton-item-third'></div></div></div></ion-item>"
    },
    link: function (scope) {
      scope.loadingItems = []
      for (let i = 0; i < 20; i++) {
        scope.loadingItems.push({flag: 1})
      }
    }
  }
}]



// WEBPACK FOOTER //
// ./src/js/directives/skeletonLoading.js